
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#fff","stroke-width":"2"}},[_c('path',{attrs:{"d":"M1 1l15 15M16 1L1 16"}})])])
          )
        }
      }
    